import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Maria G.',
      location: 'Dallas, TX',
      quote: 'PropWhiz made selling my Dallas house so easy! They gave me a fair offer and closed quickly. Highly recommend!',
      rating: 5,
      // Updated the broken image link below
      image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80',
      propertyImage: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=150&q=80'
    },
    {
      name: 'Robert T.',
      location: 'Plano, TX',
      quote: 'After trying to sell traditionally for months in Plano, PropWhiz gave me a cash offer in 24 hours. Closed in 7 days!',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80',
      propertyImage: 'https://images.unsplash.com/photo-1570129477492-45c003edd2be?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=150&q=80'
    },
    {
      name: 'Linda C.',
      location: 'Frisco, TX',
      quote: 'Yousuf was honest and professional throughout the whole process. No repairs needed, just a fair cash offer for my Frisco home.',
      rating: 5,
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80',
      propertyImage: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=150&q=80'
    }
  ];

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <svg
        key={index}
        className={`w-5 h-5 ${index < rating ? 'text-yellow-400' : 'text-gray-300'}`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ));
  };

  return (
    <section className="py-20 bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-propwhiz-dark mb-4">
            What Dallas-Fort Worth Homeowners Are Saying
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our recent DFW clients have to say.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
            >
              {/* Property Image */}
              <div className="h-40 overflow-hidden">
                <img 
                  src={testimonial.propertyImage} 
                  alt={`Property in ${testimonial.location}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              
              <div className="p-8">
                {/* Rating */}
                <div className="flex mb-4">
                  {renderStars(testimonial.rating)}
                </div>

                {/* Quote */}
                <p className="text-gray-700 text-lg mb-6 italic">
                  "{testimonial.quote}"
                </p>

                {/* Author */}
                <div className="flex items-center">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover border-2 border-propwhiz-accent"
                  />
                  <div className="ml-4">
                    <h4 className="font-bold text-lg">{testimonial.name}</h4>
                    <p className="text-gray-500 flex items-center gap-1">
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                      </svg>
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dallas Trust Badges */}
        <div className="mt-16 text-center">
          <h3 className="text-xl font-bold text-propwhiz-dark mb-6">Trusted by Dallas Homeowners</h3>
          <div className="flex flex-wrap justify-center items-center gap-8">
            <div className="text-3xl font-bold text-gray-400 hover:text-propwhiz-accent transition">Google ★★★★★</div>
            <div className="text-3xl font-bold text-gray-400 hover:text-propwhiz-accent transition">Facebook ★★★★★</div>
            <div className="text-3xl font-bold text-gray-400 hover:text-propwhiz-accent transition">BBB A+</div>
          </div>
        </div>

        {/* Dallas Success Stats */}
        <div className="mt-16 bg-gradient-to-r from-propwhiz-blue to-propwhiz-accent rounded-3xl p-8 text-white">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">50+</div>
              <div className="text-white/90">Dallas Homes Bought</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">7 Days</div>
              <div className="text-white/90">Average Close Time</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">100%</div>
              <div className="text-white/90">Local Dallas Team</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;